import { enumToStaticValue } from '@/utils'

export enum NewsDataType {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED'
}

export const newsDataTypes = enumToStaticValue(NewsDataType, 'news-data-state')
